import type { AuthDict } from '../en/auth';

export const auth: AuthDict = {
  login: {
    title: 'Logga in på ditt konto',
    subtitle: 'Välkommen tillbaka! Ange dina uppgifter.',
    emailLabel: 'E-post',
    passwordLabel: 'Lösenord',
    forgotPasswordLink: 'Glömt lösenord?',
    submit: 'Logga in',
  },
  register: {
    legacy: {
      title: 'Välkommen!',
      subtitle: 'Ange ditt lösenord för att slutföra registreringen',
      passwordLabel: 'Lösenord',
      passwordPlaceholder: '••••••••',
      passwordHint: 'Minst 8 tecken',
      confirmPasswordLabel: 'Bekräfta lösenord',
      submit: 'Skapa konto',
    },
    invitation: {
      title: 'Skapa ditt konto',
      subtitleEarlyAdopter: 'Tack för att du är en av de första att använda Queri',
      subtitleDefault: 'Slutför kontoinställningarna för att komma igång',
      subtitleJoin: (organization: string) => `Gå med i ${organization} på Queri`,
      accountFor: 'Ditt konto',
      firstNameLabel: 'Förnamn',
      firstNamePlaceholder: 'John',
      lastNameLabel: 'Efternamn',
      lastNamePlaceholder: 'Doe',
      emailLabel: 'E-post',
      emailPlaceholder: 'john.doe@company.com',
      passwordLabel: 'Lösenord',
      confirmPasswordLabel: 'Bekräfta lösenord',
      passwordPlaceholder: '••••••••',
      passwordHint: 'Minst 8 tecken',
      companyLabel: 'Företag',
      companyPlaceholder: 'Acme Inc.',
      jobTitleLabel: 'Befattning',
      jobTitlePlaceholder: 'Bolagsjurist',
      legalHoursOptional: 'Valfritt:',
      legalHoursQuestion:
        'Hur många timmar per vecka tror du att du lägger på juridiska ärenden (inklusive arbete med juridiska dokument)?',
      legalHoursPlaceholder: 't.ex. 20',
      submit: 'Skapa konto',
    },
    invalid: {
      titleExpired: 'Länken har upphört',
      titleUsed: 'Länken har redan använts',
      titleInvalid: 'Ogiltig länk',
      contactHint:
        'Kontakta personen som bjöd in dig för att begära en ny inbjudningslänk.',
    },
  },
  forgotPassword: {
    title: 'Glömt ditt lösenord?',
    subtitle: 'Ange din e-post så skickar vi dig en återställningslänk.',
    emailLabel: 'E-post',
    emailPlaceholder: 'Ange din e-post',
    submit: 'Skicka återställningslänk',
    sending: 'Skickar...',
    backToLogin: 'Tillbaka till inloggning',
    submitted: {
      title: 'Kontrollera din e-post',
      subtitle:
        'Om det finns ett konto med den e-postadressen har vi skickat dig en länk för att återställa ditt lösenord.',
      expiryNote:
        'Länken upphör att gälla om 1 timme. Om du inte ser e-postmeddelandet, kontrollera din skräppostmapp.',
    },
  },
  resetPassword: {
    title: 'Återställ ditt lösenord',
    subtitle: 'Ange ditt nya lösenord nedan.',
    newPasswordLabel: 'Nytt lösenord',
    newPasswordPlaceholder: 'Ange nytt lösenord',
    confirmPasswordLabel: 'Bekräfta lösenord',
    confirmPasswordPlaceholder: 'Bekräfta nytt lösenord',
    passwordRequirement: 'Lösenordet måste vara minst 8 tecken långt.',
    submit: 'Återställ lösenord',
    backToLogin: 'Tillbaka till inloggning',
    success: {
      title: 'Lösenordet har återställts',
      subtitle:
        'Ditt lösenord har uppdaterats. Du kan nu logga in med ditt nya lösenord.',
      goToLogin: 'Gå till inloggning',
    },
    invalidToken: {
      title: 'Ogiltig återställningslänk',
      subtitle: 'Denna länk för återställning av lösenord är ogiltig eller har upphört.',
      requestNewLink: 'Begär en ny återställningslänk',
    },
  },
  errors: {
    noInvitationCode: 'Ingen inbjudningskod angavs',
    invitationExpired: 'Denna inbjudningslänk har upphört',
    invitationUsed: 'Denna inbjudan har redan använts',
    signUpCodeRequired: 'Registreringskod krävs',
    invitationCodeRequired: 'Inbjudningskod krävs',
    hoursPerWeekInvalid: 'Antal timmar per vecka måste vara ett giltigt nummer',
    passwordsDoNotMatch: 'Lösenorden matchar inte',
    passwordTooShort: 'Lösenordet måste vara minst 8 tecken',
    invalidResetLink: 'Ogiltig återställningslänk',
  },
};
